import { isTimestampAfterCurrentDate } from "../helpers/datetimeHelper";
import { calculator } from "../services/PriceCalculatorService";
export function validEarningLoyalityRoles(LoyalityRoles, storeZone) {
  let validLoyalityRoles = LoyalityRoles.filter(
    (pt) =>
      !pt.Disabled &&
      (!pt.ExpiredDate ||
        isTimestampAfterCurrentDate(pt.ExpiredDate.seconds, storeZone))
  );
  return validLoyalityRoles;
}
export function calcLoyaltyPoints(loyalityRules, price, cartItem) {
  if (!cartItem || cartItem.RewardPoint === 0) {
    return calculateRulePoints(loyalityRules, price, false);
  }
  const productSpecialReward = cartItem.RewardPoint;
  const modifierPoints = calculateRulePoints(
    loyalityRules,
    calculator.modifierPrice(cartItem.modifiers)
  );
  return productSpecialReward + modifierPoints;
}
function calculateRulePoints(loyalityRules, price, isModifier = false) {
  var tempPrice = price;
  var temppoint = 0;
  loyalityRules.forEach((rule) => {
    if (isModifier || tempPrice >= rule.DollarSpent) {
      temppoint += ~~(tempPrice / rule.DollarSpent) * rule.Point;
      tempPrice = ~~(tempPrice % rule.DollarSpent);
    }
  });
  return temppoint;
}
export function canEarnStampForItem(stampSettings, storeZone, orderItem) {
  const criteria = stampSettings.Criteria || null;
  const validExpiry =
    !criteria.ExpiryDate ||
    (criteria.ExpiryDate &&
      isTimestampAfterCurrentDate(criteria.ExpiryDate.seconds, storeZone));

  let validProduct = true;
  if (criteria.ProductVariant) {
    validProduct =
      orderItem.id.toString() === criteria.ProductVariant.toString();
  }
  let validCategory = true;
  if (criteria.Categories && criteria.Categories.length > 0) {
    validCategory = criteria.Categories.some(
      (ct) =>
        !orderItem.ProductCategoryIDs ||
        orderItem.ProductCategoryIDs.includes(ct.toString())
    );
  }
  let validTag = true;
  if (criteria.Tags && criteria.ProductTags.length > 0) {
    validTag = criteria.ProductTags.some(
      (tg) =>
        !orderItem.ProductTagIDs ||
        orderItem.ProductTagIDs.includes(tg.toString())
    );
  }
  return validExpiry && validProduct && validCategory && validTag;
}
export function stampDiscountableItems(
  stampSettings,
  orderItems = [],
  userStamps = 0
) {
  if (userStamps < stampSettings.StampsBuy || 0) return [];
  const criteria = stampSettings.Outcome || null;
  const candidates = [];
  orderItems.forEach((orderItem) => {
    let validProduct = true;
    if (criteria.ProductVariant) {
      validProduct =
        orderItem.id.toString() === criteria.ProductVariant.toString();
    }
    let validCategory = true;
    if (criteria.Categories && criteria.Categories.length > 0) {
      validCategory = criteria.Categories.some(
        (ct) =>
          !orderItem.ProductCategoryIDs ||
          orderItem.ProductCategoryIDs.includes(ct.toString())
      );
    }
    let validTag = true;
    if (criteria.Tags && criteria.ProductTags.length > 0) {
      validTag = criteria.ProductTags.some(
        (tg) =>
          !orderItem.ProductTagIDs ||
          orderItem.ProductTagIDs.includes(tg.toString())
      );
    }
    if (validProduct && validCategory && validTag) {
      candidates.push(orderItem);
    }
  });
  // most expensive first
  const sortedCandidates = candidates.sort((a, b) => b.price - a.price);
  return sortedCandidates;
}
